import { render, staticRenderFns } from "./RoleManagement.vue?vue&type=template&id=d3efc4c4&scoped=true&"
import script from "./RoleManagement.vue?vue&type=script&lang=js&"
export * from "./RoleManagement.vue?vue&type=script&lang=js&"
import style0 from "./RoleManagement.vue?vue&type=style&index=0&id=d3efc4c4&prod&lang=css&scoped=true&"
import style1 from "./RoleManagement.vue?vue&type=style&index=1&id=d3efc4c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3efc4c4",
  null
  
)

export default component.exports